import moment from "moment";
import imgEmail from "../assets/images/platform/mail.webp";
import imgGoogle from "../assets/images/platform/google.svg";
import imgKakao from "../assets/images/platform/kakao.svg";
import imgNaver from "../assets/images/platform/naver.svg";
import imgApple from "../assets/images/platform/apple.svg";
import imgAmazon from "../assets/images/platform/amazon.svg";
import imgFirebase from "../assets/images/platform/firebase.svg";
import imgFacebook from "../assets/images/platform/facebook.svg";
import imgTiktok from "../assets/images/platform/tiktok.svg";
import imgOffline from "../assets/images/platform/offline.png";
import imgMeta from "../assets/images/platform/meta.png";
import imgInstall from "../assets/images/platform/install.png";
import imgAgency from "../assets/images/platform/agency.png";
import imgGooglePlay from "../assets/images/platform/google-play.png";
import imgAppStore from "../assets/images/platform/app-store.png";
import imgAndroid from "../assets/images/platform/android.png";
import imgIOS from "../assets/images/platform/ios.png";
import imgBaive from "../assets/images/appname/baive.png";
import imgBaiveManager from "../assets/images/appname/baive-manager.png";
import noImage from "../assets/images/no-image.jpg";
import imgInstagram from "../assets/images/platform/instagram.png";
import imgX from "../assets/images/platform/x-icon.png";
import imgYoutube from "../assets/images/platform/youtube.png";
import imgDaum from "../assets/images/platform/daum.svg";
import imgTelegram from "../assets/images/platform/telegram.png";
import imgLine from "../assets/images/platform/line.png";
import IPHONE_MODELS from "./iphone_models";

const momentTimeZone = require("moment-timezone");

export const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

export const formatNumberWithCommas = (number: number | string = 0) => {
  if (String(number) === "NaN") {
    return 0;
  }
  return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatNumberWithoutCommas = (number: number | string = 0) => {
  return parseFloat(String(number).replace(/,/g, ""));
};

export const formatDateStringTo2Row = (date: string = "") => {
  const arr = String(date).split(" ");
  return `${arr[0]} <br/> ${arr[1]}`;
};

export const formatQueryParams = (query: any = {}) => {
  const clone = structuredClone(query);
  delete clone.time_request;
  delete clone.time_request_out;
  delete clone.time_request_inner;
  // if (query?.sort_by && (String(query?.sort_by)?.includes('_') || String(query?.sort_by)?.includes('At'))) {
  //     const arr_sort_by = String(query?.sort_by)?.split('_');
  //     const join_sort_by = arr_sort_by?.map((sort: string) => `[${sort}]`).join('');
  //     clone[`sort${join_sort_by}`] = String(query?.order_by || 'desc').toLocaleLowerCase();

  //     delete clone.sort_by;
  //     delete clone.order_by;
  // }
  return clone;
};

export const formatLinkHTTPS = (linkString: string = "") => {
  if (
    String(linkString).includes("https://") ||
    String(linkString).includes("http://")
  ) {
    return linkString;
  }
  return `https://${linkString}`;
};

export const renderUrlSearchKeywordInNaver = (keyword: string = "") => {
  return `https://search.naver.com/search.naver?where=nexearch&sm=top_hty&fbm=0&ie=utf8&query=${keyword}`;
};

export const renderUrlSearchLookingUpByIP = (ip: string = "") => {
  return `https://whatismyipaddress.com/ip/${ip}`;
};

export const formatDateStringToKorea = (dateString: string = "", format = "YYYY-MM-DD HH:mm:ss") => {
  if (!dateString) return "";
  var utcCutoff = moment.tz(dateString, "UTC");
  const date = momentTimeZone(utcCutoff)
    .tz("Asia/Seoul")
    .format(format);

  return date;
};

export const formatDateString = (dateString: string = "", format = "YYYY-MM-DD") => {
  if (!dateString) return "";
  const date = moment(dateString).format(format);

  return date;
};


export const calculateDaysBetween = (startDate: Date, endDate: Date): number => {
  const timeDiff = endDate.getTime() - startDate.getTime();
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
};

export const formatDateStringToUTC = (dateString: string = "") => {
  if (!dateString) return "";
  var utcCutoff = moment.tz(dateString, "Asia/Seoul");
  //const date = momentTimeZone(utcCutoff).tz("UTC").format("YYYY-MM-DD HH:mm:ss");
  const date = momentTimeZone(utcCutoff).tz("UTC").toISOString();
  return date;
};

export const formatISOString = (date: any, type?: "start" | "end") => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;

  const localDate = new Date(date);
  if (type) {
    if (type === "start") {
      localDate.setHours(0, 0, 0, 0);
    } else {
      localDate.setHours(23, 59, 59, 999);
    }
  }

  return new Date(
    new Date(localDate).getTime() - (9 - offsetHours) * 60 * 60 * 1000
  ).toISOString();
};

export const formatSummaryStatistics = (data: any) => {
  const data_format = data?.combined?.map((item: any) => ({
    ...item,
    service: {
      hot: data?.hot?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      wallpaper: data?.wallpaper?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      snap: data?.snap?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
      photoCardNews: data?.photoCardNews?.data?.find(
        (h: any) => String(h?.date) === String(item?.date)
      ),
    },
  }));
  const data_total = {
    date: "",
    totalLikes: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalLikes) + total,
      0
    ),
    totalViews: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalViews) + total,
      0
    ),
    totalShares: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalShares) + total,
      0
    ),
    totalComments: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalComments) + total,
      0
    ),
    totalDownloads: data_format?.reduce(
      (total: number, item: any) => Number(item?.totalDownloads) + total,
      0
    ),
  };
  return {
    data: data_format,
    total: data_total,
  };
};

export const getPlatFormImage = (type: string) => {
  const formatType = type?.toLowerCase() || "";

  switch (formatType) {
    case "default":
    case "email":
      return imgEmail;
    case "google":
      return imgGoogle;
    case "naver":
      return imgNaver;
    case "kakao":
      return imgKakao;
    case "apple":
      return imgApple;
    case "amazon":
      return imgAmazon;
    case "firebase":
      return imgFirebase;
    case "facebook":
      return imgFacebook;
    case "tiktok":
      return imgTiktok;
    case "offline":
      return imgOffline;
    case "guest":
      return imgEmail;
    case "meta":
      return imgMeta;
    case "store":
      return imgInstall;
    case "agency":
      return imgAgency;
    case "google-play":
      return imgGooglePlay;
    case "app-store":
      return imgAppStore;
    case "android":
      return imgAndroid;
    case "ios":
      return imgIOS;
    default:
      return "";
  }
};

export const getOptionImage = (type: string) => {
  switch (type) {
    case "baive":
      return imgBaive;
    case "baive_manager":
      return imgBaiveManager;
    case "user":
      return imgBaive;
    case "manager":
      return imgBaiveManager;
    case "meta":
      return imgMeta;
    case "GOOGLE":
    case "google":
      return imgGoogle;
    case "FACEBOOK":
    case "facebook":
      return imgFacebook;
    case "TIKTOK":
    case "tiktok":
      return imgTiktok;
    case "INSTAGRAM":
    case "instagram":
      return imgInstagram;
    case "YOUTUBE":
      return imgYoutube;
    case "NAVER":
    case "naver":
      return imgNaver;
    case "KAKAO":
    case "KAKAO_TALK":
    case "kakaotalk":
      return imgKakao;
    case "daum":
      return imgDaum;
    case "X":
      return imgX;
    case "TELEGRAM":
      return imgTelegram;
    case "LINE":
      return imgLine;
    default:
      return noImage;
  }
};

export const formatAddressByNaver = (dataAddress: any) => {
  if (dataAddress?.length > 0) {
    const responseAddress = dataAddress?.[0];
    let address = "";

    if (responseAddress.address) {
      address = responseAddress.address;
    } else if (responseAddress.jibunAddress) {
      address = responseAddress.jibunAddress;
    } else if (responseAddress.roadAddress) {
      address = responseAddress.roadAddress;
    } else if (responseAddress.englishAddress) {
      address = responseAddress.englishAddress;
    } else if (responseAddress.jibunAddressEnglish) {
      address = responseAddress.jibunAddressEnglish;
    }

    const sido = responseAddress?.addressElements.find((i: any) =>
      i?.types.includes("SIDO")
    );

    const sigungu = responseAddress?.addressElements.find((i: any) =>
      i?.types.includes("SIGUGUN")
    );

    const dongmyun = responseAddress?.addressElements.find((i: any) =>
      i?.types.includes("DONGMYUN")
    );

    const roadname = responseAddress?.addressElements.find((i: any) =>
      i?.types.includes("ROAD_NAME")
    );

    const postalCode = responseAddress?.addressElements.find((i: any) =>
      i?.types.includes("POSTAL_CODE")
    );

    const short_address = [sigungu?.shortName, roadname?.shortName].join(
      " "
    );

    return {
      address: address,
      short_address: short_address,
      postal_code: postalCode?.longName || "",
      region1: sido?.longName || "",
      region2: sigungu?.longName || "",
      region3: dongmyun?.longName || "",
      lat: Number.parseFloat(responseAddress?.y || 0),
      long: Number.parseFloat(responseAddress?.x || 0)
    }
  }
  
  return;
} 

export const checkHasAllOption = (lstOption: any) => {
  let allOption = null;
  if (lstOption instanceof Array) {
    allOption = lstOption?.find((e: any) => e?.value === "all")
  }

  return allOption;
}

export const getKeyDeviceModelByValue = (value: string) => {
  const lowerValue = value.toLowerCase();
  return Object.keys(IPHONE_MODELS).find(key => IPHONE_MODELS[key as keyof typeof IPHONE_MODELS].toLowerCase() === lowerValue) || value;
};